import { providerList } from './utilities/providers'

import './libs/aos';
import './libs/object-fit-polyfill';
import './libs/svg-inject';
import './libs/picturefill';
import './libs/corejs';
import './libs/custom-polyfills';
import './libs/lazyload';

import { Separator } from './utilities/separator.js';
providerList.instantiate('Separator', Separator);

import { TextMaxlength } from './utilities/text-maxlength.js';
providerList.instantiate('TextMaxlength', TextMaxlength);

import { RemoveRedline } from './utilities/remove-redline.js';
providerList.instantiate('RemoveRedline', RemoveRedline);

import { Cover } from './pictures/cover';
providerList.instantiate('Cover', Cover);

import { BindMessage } from "./ui/message";
providerList.instantiate('BindMessage', BindMessage, 'gdpr');

import { Preloader } from './ui/preloader';
providerList.instantiate('Preloader', Preloader);

import { ProgressBar } from './ui/progress-bar';
providerList.instantiate('ProgressBar', ProgressBar);

import BackToTop from './ui/back-to-top';
providerList.instantiate('BackToTop', BackToTop);

import { VideoLink } from './ui/video-link';
providerList.instantiate('VideoLink', VideoLink);

import { ParallaxHeader } from './ui/parallax-header';
providerList.instantiate('ParallaxHeader', ParallaxHeader);

import {KeepCurrentScroll} from "./utilities/keep-current-scroll";
providerList.instantiate('KeepCurrentScroll', KeepCurrentScroll);
